import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-publish',
  templateUrl: './project-publish.component.html',
  styleUrls: ['./project-publish.component.css']
})
export class ProjectPublishComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
